import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { AddBulkUsersToTeamsOptions, addBulkUsersToTeams } from '~/monolith-api';

export type { AddBulkUsersToTeamsOptions };

const addBulkUsersToTeamsSchema = z.object({
   userIds: z.array(z.number()),
   teamIds: z.array(z.number()),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { userIds, teamIds } = addBulkUsersToTeamsSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await addBulkUsersToTeams({
         userIds: userIds,
         teamIds: teamIds,
         apiClient: monolithClient,
      });
      res.status(201).json(result);
   },
});

export const addBulkUsersToTeamsFromClient = ({
   userIds,
   teamIds,
}: AddBulkUsersToTeamsOptions): ReturnType<typeof addBulkUsersToTeams> => {
   return bff()
      .post('/users/addBulkUsersToTeams', {
         userIds,
         teamIds,
      })
      .then(response => response.data);
};

export type AddBulkUsersToTeamsErrorCode =
   | 'bulk_actions.limit_exceeded'
   | 'bulk_actions.invalid_userids'
   | 'bulk_actions.invalid_teamids';
